import { defineComponent } from 'vue';
import InstagramIcon from '@/assets/shared/icons/instagram.svg';
import EmailIcon from '@/assets/shared/icons/mail.svg';
import WhatsappIcon from '@/assets/shared/icons/whatsapp.svg';
import WhatsappIconBlue from '@/assets/shared/icons/whatsapp-blue.svg';
import InstagramIconBlue from '@/assets/shared/icons/instagram-blue.svg';
import EmailIconBlue from '@/assets/shared/icons/mail-blue.svg';
import ThemesHelper from '@/helpers/ThemesHelper';

export default defineComponent({
  data() {
    return {
      instagramIconPath: InstagramIcon,
      emailIconPath: EmailIcon,
      whatsappIconPath: WhatsappIcon,
      theme:
        ThemesHelper.getThemeParams('testName') ===
        'Autoteste HIV-1/2 Sure Check'
          ? 'chembio'
          : '',
    };
  },
  mounted() {
    if (this.theme === 'chembio') {
      this.instagramIconPath = InstagramIconBlue;
      this.emailIconPath = EmailIconBlue;
      this.whatsappIconPath = WhatsappIconBlue;
    }
  },
});
